const noSensorsOverlay = $blurredContainer => {

  $blurredContainer.addClass('overlay overlay--blurred');

  $('.app-contents').css('position', 'relative');
  $('.app-contents').children(':last-child').after(`
      
      <div class="modal is-open" style="margin-top: 20px; background: transparent;">
        <div class="modal-content">
          <div class="modal__content">
            <h2 class="heading--regular">Welcome to Temp Stick Enterprise!</h2>
            <p class="lead">To get started you will need to link to an existing Temp Stick account to access their sensors.</p>

            <button class="button button--medium" type="button" data-for="link-account">
              <i class="far fa-plus-circle"></i> Link Temp Stick User
            </button>
            
          </div>         
        </div>
      </div>    
      `);

  $('.app-contents button[data-for="link-account"]').on('click', e => {

    window.location.href = `${window.site.home}/accounts`;

  });

};

export default noSensorsOverlay;
